export type BulkEditEntityType = 'All' | 'Node' | 'Stope' | 'Spool';

export interface BulkEditSceneState {
  entityType: BulkEditEntityType;
  isSelecting: boolean;
  isDeleting: boolean;
  selectedIds: string[];
  cancelToolsSignal: number;
  activeToolMessage: string | null;
  version: number;
}

const defaultState: BulkEditSceneState = {
  entityType: 'All',
  isSelecting: false,
  isDeleting: false,
  selectedIds: [],
  cancelToolsSignal: 0,
  activeToolMessage: null,
  version: 0,
};

let sceneState: BulkEditSceneState = { ...defaultState };

const stateListeners: Set<() => void> = new Set();

export const getBulkEditSceneState = () => sceneState;

export const updateBulkEditSceneState = (updates: Partial<BulkEditSceneState>) => {
  sceneState = { ...sceneState, ...updates, version: sceneState.version + 1 };
  stateListeners.forEach((listener) => listener());
};

export const requestCancelTools = () => {
  sceneState = {
    ...sceneState,
    cancelToolsSignal: sceneState.cancelToolsSignal + 1,
    version: sceneState.version + 1,
  };
  stateListeners.forEach((listener) => listener());
};

export const subscribeToBulkEditSceneState = (listener: () => void): (() => void) => {
  stateListeners.add(listener);
  return () => { stateListeners.delete(listener); };
};

export const resetBulkEditSceneState = () => {
  sceneState = { ...defaultState, version: 0 };
  stateListeners.forEach((listener) => listener());
};
